<template>
  <div class="apartment-search-full-all-types">
    <div class="apartment-search-full__wrapper">
      <ApartmentSearchFormAllTypes
        :preset="preset"
        size="full"
        @submit-all-types="submitAllTypes"
      />
      </div>
      <div class="container-lg">
      <LoadSpinner
        v-if="loading"
        class="apartment-search-full__loading"
      />

      <template v-else>

        <div class="apartment-search-full__results--header">

          <div
            v-if="submitted"
            class="apartment-search-full__title"
          >
            <template v-if="apartments.length > 0">
              {{translate('Vapaat ja vapautumassa olevat asunnot')}}
              {{sprintf(translate('%s kpl'), apartmentsTotalCount)}}
              <template>
                <ApartmentCountPerType :apartmentCountData="apartmentCountData" :apartmentCounts="apartmentCounts"/>
              </template>


            </template>
            <template v-else-if="housingLocalities.length > 0">
              {{translate('Haulla ei löytynyt vapaita asuntoja.')}}
            </template>
            <template v-else>
              {{translate('Haulla ei löytynyt tuloksia.')}}
            </template>
          </div>

          <div
            v-if="apartments.length > 0"
            class="apartment-search-full__sorting"
          >
            <div
              v-if="currentView === 'list'"
              class="form-select-wrapper apartment-search-full__sorting--sort-options"
            >
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="sortChoice"
                @change="sortingHandler(sortChoice)"
              >
                <option
                  v-for="option in options"
                  :key="option.value"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>

            <button
              v-if="currentView === 'list'"
              class="btn btn--small btn--white apartment-search-full__sorting--display"
              type="button"
              @click="switchView"
            >
              <MapPinIcon />
                {{translate('Karttanäkymä')}}
            </button>

						<button
              v-if="currentView === 'map'"
              class="btn btn--small btn--white apartment-search-full__sorting--display"
              type="button"
              @click="switchView"
            >
              <ListIcon />
                {{translate('Listanäkymä')}}
            </button>

          </div><!-- .apartment-search-full__sorting -->
        </div><!-- .apartment-search-full__results--header -->

        <ApartmentSearchMap
          v-if="currentView === 'map'"
          :apartments="apartments"
        />

        <div v-if="currentView === 'list'">
        <div
          v-if="apartments.length > 0"
          class="apartment-search-full__grid listing-card-grid"
        >
          <div class="listing-card-grid__grid">
            <div
              v-for="apartment in apartments"
              class="listing-card-grid__column"
            >

              <ApartmentCard
                :apartment="apartment"
                :get-params="{back: true}"
                class="listing-card-grid__item"
              />
            </div>
          </div>
        </div>

        <div
          v-if="submitted"
          class="apartment-search-full__load-more-container"
        >
          <button
            v-if="!isLastPage"
            :disabled="loadingMore"
            class="apartment-search-full__load-more btn"
            :class="`btn--green`"
            @click="loadMoreAllTypes"
          >
            <LoadSpinner
              v-if="loadingMore"
              :margin="false"
            />
            <template v-else>
              {{translate('Lataa lisää hakutuloksia')}}
            </template>
          </button>
        </div>

        </div><!-- end v-if list -->
      </template>
    </div>

    <div v-if="currentView === 'list'">
    <div
      class="apartment-search-full__housing-localities"
      v-if="!loading && housingLocalities.length > 0"
    >
      <div class="container">
        <h2 class="h4 h--centered-divider">
          {{translate('Kohteet, joissa hakuasi vastaavia ei vapaana olevia asuntoja')}}
        </h2>

        <div class="apartment-search-full__grid listing-card-grid">
          <div class="listing-card-grid__grid">
            <div
              v-for="housingLocality in housingLocalities"
              class="listing-card-grid__column"
            >
              <HousingLocalityCard
                :housing-locality="housingLocality"
                :get-params="{back: true}"
                class="listing-card-grid__item"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div><!-- end v-if list -->
  </div>
</template>

<script>
  import axios from 'axios';
  import {sprintf} from 'sprintf-js';

  import globals from '../lib/globals';
  import utils from './mixins/utils';
  //import ApartmentSearchForm from './components/ApartmentSearchForm';
  import ApartmentSearchFormAllTypes from './components/ApartmentSearchFormAllTypes';
  import ApartmentCard from './components/ApartmentCard';
  import HousingLocalityCard from './components/HousingLocalityCard';
  import LoadSpinner from './components/LoadSpinner';
  import Multiselect from 'vue-multiselect';
  import ApartmentCountPerType from './components/ApartmentCountPerType.vue';
  import ApartmentSearchMap from './components/ApartmentSearchMap.vue';

  // Icons.
  import MapPinIcon from './icons/MapPinIcon.vue';
  import ListIcon from './icons/ListIcon.vue';

  export default {
    components: {
      ApartmentSearchFormAllTypes,
      ApartmentCard,
      HousingLocalityCard,
      LoadSpinner,
      Multiselect,
      MapPinIcon,
			ListIcon,
      ApartmentCountPerType,
      ApartmentSearchMap
    },
    mixins: [
      utils.translate,
      utils.hasApartmentUrl
    ],
    props: {
      preset: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        page: 0,
        isLastPage: false,
        // When the form is submitted, we create a copy of its state that is used to show and load more results.
        formCopy: null,
        submitted: false,
        loading: false,
        loadingMore: false,
        apartments: [],
        housingLocalities: [],
        sortChoice: {value: 'created_at,desc', name: this.translate('Uusimmat ilmoitukset ensin')},
        sortingCriteria: 'created_at',
        sortingDirection: 'desc',
        formType: 'right-of-occupancy',
        apartmentsTotalCount: 0,
        options: [
          { value: "created_at,asc", name: this.translate("Vanhimmat ilmoitukset ensin") },
          { value: "created_at,desc", name: this.translate("Uusimmat ilmoitukset ensin") },
          { value: "mpc_esittelypaiva,asc,3", name: this.translate("Esittelyssä olevat ensin") },
          { value: "mpc_vastike,asc,1", name: this.translate("Edullisimmat ensin (vastike)") },
          { value: "mpc_vastike,desc,1", name: this.translate("Kalleimmat ensin (vastike)") },
          { value: "mpc_pinta_ala,asc,1", name: this.translate("Pienimmät ensin") },
          { value: "mpc_pinta_ala,desc,1", name: this.translate("Suurimmat ensin") },
          { value: "housing_locality.mpc_valmistumispaiva,asc,2", name: this.translate("Vanhimmat ensin (rakennusvuosi)") },
          { value: "housing_locality.mpc_valmistumispaiva,desc,2", name: this.translate("Uusimmat ensin (rakennusvuosi)") },
        ],
        apartmentCounts: {
          'owner-occupancy': [
            { name: this.translate('Omistusasunnot'), count: 0, }
          ],
          'right-of-occupancy': [
            { name: this.translate('ASO-asunnot'), count: 0, }
          ],
          'rental': [
            { name: this.translate('Vuokra-asunnot'), count: 0, }
          ]
        },
        currentView: 'list'
      };
    },
    computed: {
      color() {
        const colors = {
          'rental': 'green',
          'right-of-occupancy': 'green',
          'owner-occupancy': 'green',
        };
        const type = this.formCopy && this.formCopy.type;
        return colors.hasOwnProperty(type) ? colors[type] : 'default';
      },
      apartmentCountData() {
        // Flatten the nested arrays into one array
        return Object.values(this.apartmentCounts).flat();
      }
    },
    methods: {
      sprintf,
      async submitAllTypes(form) {
        this.submitted = true;
        this.formCopy = form;
        this.formCopy.sortingCriteria = this.sortingCriteria;
        this.formCopy.sortingDirection = this.sortingDirection;
        this.page = 0;
        this.isLastPage = false;
        this.loading = true;
        this.updatePriceOptions(this.formCopy.type);
        this.show_campaign = this.formCopy?.show_campaign;

        // Disable these fields when the corresponding type is not selected
        //  'right-of-occupancy': ['maxPrice', 'maxTotalPrice'],
        //  'owner-occupancy': ['minDebtFreePrice', 'maxDebtFreePrice'],
        //  'rental': ['maxPrice']
        if (!this.formCopy.type.includes('owner-occupancy')) {
          form.minDebtFreePrice = null;
          form.maxDebtFreePrice = null;
        }
        if (!this.formCopy.type.includes('right-of-occupancy')) {
          form.maxTotalPrice = null;
        }
        if (!this.formCopy.type.includes('right-of-occupancy') && !this.formCopy.type.includes('rental')) {
          form.maxPrice = null;
        }
        this.currentView === 'map' ? form.map = 1 : form.map = 0;

        const url = `${globals.urlIntegrationApi}/public/apartments-filter-all-types-search`;
        const response = await axios.post(url, form);

        //this.apartments = response.data.apartments;
        this.apartments = response.data.apartments.filter(apartment => {
          return this.hasApartmentUrl(apartment); // replace this condition with your own
        });

        // Populate the apartmentCounts object with the counts from the response.
        Object.keys(this.apartmentCounts).forEach(rawKey => {
          const key = String(rawKey); // Explicit cast to string.
          if( response.data.totalCount.hasOwnProperty(key) ) {
            this.apartmentCounts[key][0].count = response.data.totalCount[key];
          } else {
            this.apartmentCounts[key][0].count = 0;
          }
        });

        // Calculate the total count of apartments.
        this.apartmentsTotalCount = Object.values(response.data.totalCount).reduce((sum, value) => sum + value, 0);

        this.housingLocalities = response.data.housing_localities;
        this.isLastPage = response.data.last;
        this.loading = false;
      },
      async loadMoreAllTypes() {
        this.page = this.page + 1;
        this.loadingMore = true;

        const url = `${globals.urlIntegrationApi}/public/apartments-filter-all-types-search`;
        const response = await axios.post(url, {...this.formCopy, page: this.page});

        this.apartments = [...this.apartments, ...response.data.apartments];
        this.isLastPage = response.data.last;
        this.loadingMore = false;
      },
      updatePriceOptions(formType) {
        // TODO this needs to be made to work with multiple form types
        // If form type is correct, options will not be mutated.
        // Note: When this change will be done consider change
        // this to the array kind of label, value structure.
        /**
         * Example
        {
          [
            'label' => 'vuokra',
            'value' => 'mpc_vuokra'
          ],
          [
            ...
          ]
        }
        */
        if (formType === this.formType) {
          return;
        }

        // Update rental status.
        this.formType = formType;

        let sortFields = '';
        /* let sortStr = ''; */
        let sortStrArray = []; // Use an array to store the names

        for (const type of this.formType) {
          if (type === 'rental') {
            sortFields += 'mpc_vuokra|';
            sortStrArray.push(
              this.translate('vuokra')
            );
          } else if (type === 'owner-occupancy') {
            sortFields += 'ava_Velatonhinta|';
            sortStrArray.push(
              this.translate('velaton hinta')
            );
          } else {
            sortFields += 'mpc_vastike|';
            sortStrArray.push(
              this.translate('vastike')
            );
          }
        }

        // Sort items to be always in the same order,
        // otherwise clicking order might effect this.
        // Note: the values aren't in sync by the order
        // but it shouldn't matter for the functionality,
        // Consider ordering also the values if the previously mentioned changes will be done.
        let sortedSortStr = sortStrArray.sort().join('/');

        // Options array items [3] and [4] contain price options.
        if (sortFields !== '' && sortedSortStr !== '') {
          this.options[3] = {
            value: sortFields.slice(0,-1) + ",asc,1",
            name: this.translate( 'Edullisimmat ensin' ) + " (" + sortedSortStr + ")"
          }
          this.options[4] = {
            value: sortFields.slice(0,-1) + ",desc,1",
            name: this.translate( 'Kalleimmat ensin' ) + " (" + sortedSortStr + ")"
          }
        }
        return;
      },
      sortingHandler(sortChoice) {

        // This function handles dropdown changes.
        this.sortingCriteria = sortChoice.value.split(',')[0];
        this.sortingDirection = sortChoice.value.split(',')[1];

        // Use quick sorting when all apartments are loaded.
        // KS 2025-03: Disable quick sorting for now
        //   (needs refactoring because of multiple modes and discount)
        //if (this.isLastPage) {
        //  this.sortApartments(sortChoice);
        //  return;
        //}

        this.formCopy.sortingCriteria = this.sortingCriteria;
        this.formCopy.sortingDirection = this.sortingDirection;
        this.submitAllTypes(this.formCopy);
        return;
      },
      sortApartments(sortChoice) {
        // Options have property name, sorting direction and optional
        // flags for parsing.
        let criteria = sortChoice.value.split(',')[0];
        let direction = sortChoice.value.split(',')[1];

        // Flags:
        // 0 - no parsing
        // 1 - parse float
        // 2 - property is nested
        // 3 - property may contain null
        let flag = parseInt(sortChoice.value.split(',')[2]) || 0;

        // Sorting logic switch.
        switch (flag) {
          case 0:
            this.apartments = [...this.apartments
                .sort((apartment1, apartment2) =>
                apartment1[criteria] > apartment2[criteria] ? 1 : -1)];
            break;

          case 1:
            this.apartments = [...this.apartments
                .sort((apartment1, apartment2) =>
                parseFloat(apartment1[criteria]) > parseFloat(apartment2[criteria]) ? 1 : -1)];
            break;

          case 2:
            this.apartments = [...this.apartments
                .sort((apartment1, apartment2) =>
                apartment1.housing_locality.mpc_valmistumispaiva > apartment2.housing_locality.mpc_valmistumispaiva ? 1 : -1)];
            break;

          case 3:
            let showcaseApartments = [...this.apartments];
            showcaseApartments = this.handleShowcaseApartments(showcaseApartments, criteria);
            this.apartments = showcaseApartments;
            break;

          default:
            break;
        }

        if (direction === 'desc') {
          this.apartments = this.apartments.reverse();
        }

        return;
      },
      // Sort showcase apartments
      handleShowcaseApartments(apartments, criteria) {
        let future = apartments.filter(apartment => Date.parse(apartment[criteria]) > Date.now())
        future.sort((apartment1, apartment2) => apartment1[criteria] > apartment2[criteria] ? 1 : -1);
        let past = apartments.filter(apartment => Date.parse(apartment[criteria]) < Date.now());
        past.sort((apartment1, apartment2) => apartment1[criteria] > apartment2[criteria] ? -1 : 1);
        let nullDates = apartments.filter(apartment => apartment[criteria] === null);

        return future.concat(past).concat(nullDates);
      },
      splitCityDistrictStrings() {
        this.cities = [];
        this.districts = [];
        this.cityDistrictStrings.forEach(item => {
          let parts = item?.name.split(" - ");
          this.cities.push(parts[0]);
          this.districts.push(parts[1]);

          this.cities = [...new Set(this.cities)];  //remove duplicates
          this.districts = [...new Set(this.districts)]; //remove duplicates
        });
      },
      async searchCity() {
        const that = this;
        if(this.isMultipleDistricts || (Array.isArray(that.districts) && that.districts.length <= 0)) {
          this.clearCityDistrict();
          return;
        }
        const adminurl = avain.adminUrl + 'admin-ajax.php' ?? '/wp-admin/admin-ajax.php';
        const url = adminurl + `?action=search_cities&query=` + that.districts[0];
        const response = await axios.get(url);

        if (response.data) {
          that.city.content = response.data.fields.city_introductory_text;
          that.city.name = response.data.city;

          Object.keys(response.data.fields.city_districts).forEach(key => {
            const item = response.data.fields.city_districts[key];
            that.district.name = item.district_name;
            that.district.content = item.district_content;
            that.district.newsContent = item.district_news_content;
            that.district.image = item.district_news_image;
            that.district.showNewsContent = item.show_district_news;
          });
        } else {
          that.clearCityDistrict();
        }

      },
      clearCity() {
        this.city.name = '';
        this.city.content = '';
      },
      clearDistrict() {
        this.district.content = '';
        this.district.newsContent = '';
        this.district.showNewsContent = false;
        this.district.image = '';
        this.district.name = '';
      },
      clearCityDistrict() {
        this.clearDistrict();
        this.clearCity();
      },
      switchView() {
        this.currentView = this.currentView === 'list' ? 'map' : 'list';
        if (this.preset) {
          this.submitAllTypes(this.preset);
        }
      },

    },
    mounted() {
      if (this.preset) {
        this.submitAllTypes(this.preset);
      }
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .apartment-search-full {
  }

  .apartment-search-full__wrapper {
    background-color: $color-pink-light-2025;
  }

  .apartment-search-full__loading {
    height: r(128);
  }

  .apartment-search-full__apartments {
    overflow: hidden;
  }

  .apartment-search-full__results--header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: r(26);
    margin-bottom: r(40);
    gap: 1rem;
  }

  .apartment-search-full__title {
    font-family: $ff-lato;
    font-size: r(18);
    line-height: r(28);
    font-weight: 700;
    color: $color-black;
    text-align: left;
    margin: 0;
  }

  .apartment-search-full__sorting {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    width: max-content;
    justify-content: flex-end;

    @include media-breakpoint-down(md) {
      > * {
        flex-grow: 1;
      }
    }

    select {
      margin: 0;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    option {
      color: $color-black;
    }

    @include media-breakpoint-down(md) {
      flex-grow: 1;
    }
  }

  .apartment-search-full__sorting--type {
    display: flex;
    flex-wrap: nowrap;
    gap: r(18);
    font-family: $ff-lato;
    font-size: r(16);
    font-weight: 500;
    line-height: r(24);
    letter-spacing: -1.5%;
    margin-right: auto;
    a.current {
      text-decoration: underline;
    }
    a {
      padding: r(8) 0;
      hyphens: none;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }

  .apartment-search-full__sorting--show-floorplan {
    font-size: r(16);
    .form-check-input {
      border-style: dotted;
    }
    label {
      padding: r(8) 0;
      hyphens: none;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }

  .apartment-search-full__sorting--display {
    grid-row: 1;
    justify-content: flex-start;
    hyphens: none;
  }

  .apartment-search-full__sorting--sort-options {
    grid-row: 2;
  }

  .apartment-search-full__grid {
    margin: 0 0 r(48);
  }

  .apartment-search-full__load-more-container {
    display: flex;
    justify-content: center;
    margin-bottom: r(48);
  }

  .apartment-search-full__load-more {
    min-width: r(256);
  }

  .apartment-search-full__housing-localities {
    overflow: hidden;
    padding-bottom: r(32);
    background-color: $color-white;
  }
</style>
